import { PRIMARY_COLOR, SECONDARY_COLOR } from '../constants/colors';

const palette = {
  primary: {
    main: PRIMARY_COLOR,
  },
  secondary: {
    main: SECONDARY_COLOR,
  },
};
export default palette;
